<style lang="scss" scoped="scoped">
// ::-webkit-scrollbar {
// 	width: 0 !important
// }
::-webkit-scrollbar {
  display: none;
}

.vue-grid-item {
  // overflow: auto;
  box-sizing: border-box;
  position: relative;
}

.vue-grid-item.vue-grid-placeholder {
  background: #419fff !important;
}

.el-dropdown-link {
  cursor: pointer;
  color: #419fff;
}

.bg {
  //背景图,fit scall
  background-image: url("../../../../../../assets/img/web/weier/production/beijing.jpg");
  background-size: cover;
  background-repeat: no-repeat;
}

.header-bg {
  //背景图平铺
  background-image: url("../../../../../../assets/img/web/weier/production/biaoti.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

// .vue-grid-layout::-webkit-scrollbar {
// 	width: 0 !important
// }

.module-grid {
  background: transparent;
}
</style>
<style lang="scss">
.el-popper {
  margin-right: 10px;
}

.monitorWorshop .el-input__inner {
  color: #419fff;
  border: none;
  background-color: transparent;
  text-align: right;
  width: 260px;
}

.monitorWorshop .el-cascader .el-input .el-icon-arrow-down {
  color: #419fff;
}

.monitorWorshop .el-input__inner::-webkit-input-placeholder {
  color: #419fff;
}
</style>
<template>
  <div style="display: inline;">
    <div class="bg" style="position: absolute;height: 100%;width: 100%;box-sizing: border-box;">
      <div ref="header" style="padding: 0px 0px  0px  0px;">
        <div class="header-bg" style="width: 100%;height: 69px;padding:10px 10px;display: flex;justify-content: space-between;align-items: center;">
          <div style="width: 7%;cursor: pointer;">
            <img @click="utils.event_hub.$emit('TOGGLE_TABBAR', !store.state.is_monitor_full)" style="width: 100%;height: auto;" src="../../../../../../assets/img/web/weier/production/logo.png" />
          </div>
          <div style="font-weight: 700;font-size: 30px;color: white;">

          </div>
          <div class="monitorWorshop" style="width: 200px;display: flex;flex-direction: column;justify-content: center;align-items: flex-end;">
            <p style="font-size: 14px;color:rgba(93, 165, 236, 1);">{{ store.state.currentTime }}</p>
            <div style="display: flex;align-items: center;color: rgba(93, 165, 236, 1);">
              <yi_data_select :type="'organization'" :ids.sync="orgId"> </yi_data_select>

            </div>
          </div>
        </div>
      </div>
      <div style="padding: 0px 0px 0px  0px;">
        <grid-layout v-if="gridContainerHeight != 0" :layout.sync="layout" :col-num="24" :maxRows="24" :row-height="gridRowHeihgt" :is-draggable="false" :is-resizable="false" :is-mirrored="false" :vertical-compact="true" :margin="[10, 10]" :use-css-transforms="true" :style="{ height: gridContainerHeight + 'px' }" style="overflow: auto;">
          <grid-item v-for="item in layout" :x="item.x" :y="item.y" :w="item.w" :h="item.h" :i="item.i" :key="item.i">
            <component :ref="'grid_' + item.i" v-bind:is="item.i" :orgId="orgId" :datas="datas[item.i]"> </component>
          </grid-item>
        </grid-layout>
      </div>
    </div>


  </div>
</template>
<script type="text/javascript">
import VueGridLayout from "vue-grid-layout";
import hour_output from "@@/pages/web/customize/weier/monitor/production/hour_output";
import shengchan from "@@/pages/web/customize/weier/monitor/production/shengchan";
import seven_month from "@@/pages/web/customize/weier/monitor/production/seven_month";
import seven_day from "@@/pages/web/customize/weier/monitor/production/seven_day";
import oee from "@@/pages/web/customize/weier/monitor/production/oee";
import banci from "@@/pages/web/customize/weier/monitor/production/banci";
import _video from "@@/pages/web/customize/weier/monitor/production/video";
import huanmotiaoji from "@@/pages/web/customize/weier/monitor/production/huanmotiaoji";
import shebeijiankong from "@@/pages/web/customize/weier/monitor/production/shebeijiankong";
import kaijiqingkuang from "@@/pages/web/customize/weier/monitor/production/kaijiqingkuang";

export default {
  name: "web_customize_weier_monitor_production_index",
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    hour_output: hour_output,
    seven_month: seven_month,
    seven_day: seven_day,
    oee: oee,
    shengchan: shengchan,
    banci: banci,
    _video: _video,
    huanmotiaoji: huanmotiaoji,
    shebeijiankong: shebeijiankong,
    kaijiqingkuang: kaijiqingkuang,
  },

  data() {
    return {
      datas: {},
      orgId: null,
      gridContainerHeight: 0,
      gridRowHeihgt: 0,
      layout: [],
      monitorSetting: {},
      canWatch: false
    };
  },
  created() {
    this.orgId = (localStorage.getItem("WEIER_MONITOR_WORKSHOP_ORGID_" + this.store.state.customer.code) != null && !isNaN(parseInt(localStorage.getItem("WEIER_MONITOR_WORKSHOP_ORGID_" + this.store.state.customer.code)))) ? parseInt(localStorage.getItem("WEIER_MONITOR_WORKSHOP_ORGID_" + this.store.state.customer.code)) : this.store.state.organizations[0].id

    this.setLayout();
    this.utils.event_hub.$emit("TOGGLE_TABBAR", true);

    this.timmer = setInterval(() => {
      this.getManagement();
    }, 120000);
    setTimeout(() => {
      //等待获取高度再生成,resize是延迟800的，这里1000
      this.getManagement();
    }, 1000);

    setTimeout(() => {
      this.canWatch = true;
    }, 1000);

  },

  watch: {
    "orgId"(newValue, oldValue) {

      if (this.canWatch == false) {
        return
      }

      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.getManagement();
      //保存

      localStorage.setItem("WEIER_MONITOR_WORKSHOP_ORGID_" + this.store.state.customer.code, newValue)
    },
  },
  activated() {
    this.resize();
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on("RESIZE", () => {
      this.resize();
    });

  },
  destroyed() {
  },
  methods: {
    getManagement() {

      this.http.get("/custom/weier/notice/board/getSevenMonthAndSevenDayProduct", {
        params: {
          orgId: this.orgId,
        },
      }).then((res) => {




        this.$set(this.datas, "seven_day", res.data.daysNoticeBoardProduct);
        this.$set(this.datas, "seven_month", res.data.monthNoticeBoardProduct);
        this.resize();
      });


      this.http.get("/web/equipment/getShitHourProduct", {
        params: {
          orgId: this.orgId,
        },
      }).then((res) => {
        this.$set(this.datas, "hour_output", res.data);
        this.resize();
      });


      this.http.get("/custom/weier/notice/board/getProductionData", {
        params: {
          orgId: this.orgId,
        },
      }).then((res) => {
        this.$set(this.datas, "shengchan", res.data);
        this.resize();
      });


      this.http.get("/custom/weier/notice/board/getTotalAnalysis", {
        params: {
          orgId: this.orgId,
        },
      }).then((res) => {
        this.$set(this.datas, "oee", res.data);
        this.resize();
      });

      this.http.get("/custom/weier/notice/board/getChangeMouldDebugEquipmentTimeAnalysis", {
        params: {
          orgId: this.orgId,
        },
      }).then((res) => {
        this.$set(this.datas, "huanmotiaoji", res.data);
        this.resize();
      });

      this.http.get("/custom/weier/notice/board/getEmployeeAnalysis", {
        params: {
          orgId: this.orgId,
        },
      }).then((res) => {
        this.$set(this.datas, "banci", res.data);
        this.resize();
      });

      this.http.get("/custom/weier/notice/board/statisticsRecentlyOpenMachineBy7daysData", {
        params: {
          orgId: this.orgId,
        },
      }).then((res) => {
        this.$set(this.datas, "kaijiqingkuang", res.data);
        this.resize();
      });

      this.http.get("/web/equipment/getEquipmentListByOrgId", {
        params: {
          orgId: this.orgId,
        },
      }).then((res) => {
        this.$set(this.datas, "shebeijiankong", res.data);
        this.resize();
      });


    },
    setLayout() {
      this.monitorSetting = JSON.parse(localStorage.getItem("MONITOR_SETTING"));
      if (this.monitorSetting == null) {
        this.monitorSetting = {};
      }
      if (this.monitorSetting.WEIER_MONITOR_PRODUCTION_TEMPLATE == null) {
        this.monitorSetting.WEIER_MONITOR_PRODUCTION_TEMPLATE = "moren";
      }


      if (this.monitorSetting.WEIER_MONITOR_PRODUCTION_TEMPLATES == null) {
        this.monitorSetting.WEIER_MONITOR_PRODUCTION_TEMPLATES = {
          moren: [
            {
              x: 0,
              y: 0,
              w: 7,
              h: 8, //应该是6
              i: "seven_day",
            },
            {
              x: 7,
              y: 0,
              w: 10,
              h: 8, //应该是6
              i: "shengchan",
            },
            {
              x: 17,
              y: 0,
              w: 7,
              h: 6,
              i: "oee",
            },
            {
              x: 17,
              y: 6,
              w: 7,
              h: 4,
              i: "shebeijiankong",
            },
            {
              x: 0,
              y: 8,
              w: 7,
              h: 8, //应该是6
              i: "seven_month",
            },
            {
              x: 7,
              y: 8,
              w: 10,
              h: 8, //应该是6
              i: "_video",
            },
            {
              x: 17,
              y: 10,
              w: 7,
              h: 6,
              i: "banci",
            },

            {
              x: 0,
              y: 16,
              w: 7,
              h: 8, //应该是6
              i: "kaijiqingkuang",
            },

            {
              x: 7,
              y: 16,
              w: 10,
              h: 8, //应该是6
              i: "hour_output",
            },

            {
              x: 17,
              y: 16,
              w: 7,
              h: 8,
              i: "huanmotiaoji",
            },


          ],
        };
      }

      this.layout = this.monitorSetting.WEIER_MONITOR_PRODUCTION_TEMPLATES[this.monitorSetting.WEIER_MONITOR_PRODUCTION_TEMPLATE];
    },

    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.header) {
          return;
        }
        this.gridContainerHeight = this.store.state.router_view_height - this.$refs.header.offsetHeight - 10;
        this.gridRowHeihgt = (this.gridContainerHeight - 240) / 24;
      }, 500);
    },
  },
};
</script>
